module.exports = __webpack_public_path__ + "img/violet_038.1dbf9a85.png";